import { Component, ElementRef, OnDestroy, OnInit, ViewChild, EventEmitter, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { SettingsService } from '../../../../services/settings.service';
import { ProjectService } from '../../../../services/project.service';
import { MatSelectChange } from '@angular/material/select';
import { RatingService } from '../../../../services/rating.service';
import { MoodQuestion } from '../../../../models/moodQuestion';

@Component({
  selector: 'app-team-mood-question-edit',
  templateUrl: './team-mood-question-edit.component.html',
  styleUrls: ['./team-mood-question-edit.component.scss']
  })
export class TeamMoodQuestionEditComponent implements OnInit, OnDestroy {
  static widgetName = 'teamMoodQuestionEdit';
  languages: string[];
  @ViewChild('divcontainer') private element: ElementRef;
  @Output() backPressed = new EventEmitter<void>();
  private event: Subscription[] = [];
  public projectName: string;
  public projectId: number;
  public allQuestions: MoodQuestion[] = [];
  public deletedQuestions: MoodQuestion[] = [];
  public initialized = true;
  public newQuestionValue = '';
  public newQuestionColor = 'rgba(255, 0, 0, 1)';
  public placeholderNewVote;

  constructor(private translate: TranslateService,
    private settingsService: SettingsService,
    private ratingService: RatingService,
    private projectService: ProjectService) {
    this.languages = this.translate.getLangs();
  }

  changeLanguage(event: MatSelectChange) {
    this.translate.use(event.value);
  }

  ngOnInit() {
    this.event.push(this.translate.stream('widgets.teamMood.addNewQuestionHere').subscribe(res => {
      this.placeholderNewVote = res;
    }));
    this.event.push(this.settingsService.getUpdateObservable().subscribe(res => {
      this.loadInfo();
    }));
    this.loadInfo();
  }

  ngOnDestroy(): void {
    for (const ev of this.event) {
      ev.unsubscribe();
    }
  }

  loadInfo() {
    this.projectName = this.settingsService.getProjectName();
    this.projectService.getProjectByKey(this.projectName).subscribe(val => {
      this.projectId = val.id;
      this.ratingService.getAllQuestions(this.projectName).subscribe(res => {
        this.allQuestions = res;
        this.initialized = res.length > 0;
      });
    });
  }

  initQuestions() {
    this.ratingService.getInitStandardQuestions(this.settingsService.getProjectName()).subscribe(res => {
      this.allQuestions = res;
      this.initialized = res.length > 0;
    });
  }

  changeActive(id: number) {
    const changedQuestion = this.allQuestions.find(x => x.id === id);
    changedQuestion.active = !changedQuestion.active;
  }

  changeColor(id: number, newColor: string) {
    const changedQuestion = this.allQuestions.find(x => x.id === id);
    changedQuestion.color = newColor;
  }

  changeName(id: number, newName: string) {
    const changedQuestion = this.allQuestions.find(x => x.id === id);
    changedQuestion.name = newName;
  }

  addNewQuestion(): void {
    const newQuestion: MoodQuestion = new MoodQuestion(null, this.newQuestionValue, this.newQuestionColor, this.projectId, true, false);
    if (this.newQuestionValue !== '') {
      this.allQuestions.push(newQuestion);
      this.initialized = this.allQuestions.length > 0;
    }
    this.newQuestionValue = '';
    this.newQuestionColor = 'rgba(255, 0, 0, 1)';
  }

  deleteQuestion(id: number) {
    const deletedQuestion = this.allQuestions.find(x => x.id === id);
    deletedQuestion.deleted = true;
    deletedQuestion.active = false;
    const index: number = this.allQuestions.indexOf(deletedQuestion);
    if (index !== -1) {
      this.allQuestions.splice(index, 1);
      this.deletedQuestions.push(deletedQuestion);
    }
    this.initialized = this.allQuestions.length > 0;
  }

  confirm(){
    const questions: MoodQuestion[] = [];

    this.allQuestions.forEach(element => {
      questions.push(element);
    });

    this.deletedQuestions.forEach(element => {
      questions.push(element);
    });

    this.ratingService.updateQuestion(this.settingsService.getProjectName(), questions).subscribe(() => {
      this.goBack();
    });
  }

  cancel(){
    this.goBack();
  }

  goBack(){
    this.backPressed.emit();
    this.ratingService.sendVoteSettingsChanged();
  }
}
